import styled from 'styled-components'
import { Box, ButtonStyled, SpanStyled, TextStyled } from './Elements';
import { useTranslation } from 'react-i18next'
import { Spinner } from "react-bootstrap";
import { ArrowDown } from './AllImages';
import { useRef } from "react";
export const sliceProps = (props, sub) => {
    const { children, ...otherProps } = props;
    sub.forEach(prop => delete otherProps[prop]);
    return otherProps;
}

export const ButtonWithIcon = (props) => {
    const unwantedProps = ['icon', 'label', 'className'];
    return (
        <ButtonWrapper {...sliceProps(props, unwantedProps)} className={`d-flex align-items-center ${props.className || ''}`}>
            <button {...sliceProps(props, unwantedProps)} className={`${!props.icon ? 'Btn-icon' : ''}`} autoComplete='false'>
                {props.icon && (
                    <props.icon width='18px' />
                )}
                <SpanStyled color='var(--secondaryColor)' family="var(--bold)" size='16px'>{props.label ? props.label : ''}</SpanStyled>
            </button>
        </ButtonWrapper>
    )
}
export const ButtonWithIcon2 = (props) => {
    const unwantedProps = ['icon', 'label', 'className'];
    return (
        <ButtonWrapper2 {...sliceProps(props, unwantedProps)} className={`d-flex align-items-center ${props.className || ''}`}>
            <button {...sliceProps(props, unwantedProps)} className={`${!props.icon ? 'Btn-icon' : ''}`} autoComplete='false'>
                {props.icon && (
                    <props.icon width='24px' height='24px' />
                )}
                <SpanStyled color='var(--secondaryColor)' family="var(--bold)" size='16px'>{props.label ? props.label : ''}</SpanStyled>
            </button>
        </ButtonWrapper2>
    )
}
export const ContactButton = (props) => {
    const unwantedProps = ['icon', 'label', 'className', 'colorSp'];
    return (
        <ContactWrapper {...sliceProps(props, unwantedProps)} className={`d-flex align-items-center ${props.className || ''}`}>
            <button {...sliceProps(props, unwantedProps)} className={`${!props.icon ? 'Btn-icon' : ''}`} autoComplete='false'>
                
                <span>{props.label ? props.label : ''}</span>
                {props.icon && (
                    <props.icon width='20px' />
                )}
            </button>
        </ContactWrapper>
    )
}
export const ContactButtonHref = (props) => {
    const unwantedProps = ['icon', 'label', 'className', 'colorSp', 'href'];
    return (
        <ContactWrapper {...sliceProps(props, unwantedProps)} className={`d-flex align-items-center ${props.className || ''}`}>
            <a href={props.href} {...sliceProps(props, unwantedProps)} className={`${!props.icon ? 'Btn-icon' : ''}`} autoComplete='false'>
                
                <span>{props.label ? props.label : ''}</span>
                {props.icon && (
                    <props.icon width='20px' />
                )}
            </a>
        </ContactWrapper>
    )
}
export const InputWithIcon = (props) => {
    const unwantedProps = ['icon', "label"];
    return (
        <InputStyledWrap className='position-relative' >
            <InputStyled {...sliceProps(props, unwantedProps)} className={`w-100 ${!props.icon ? 'no-icon' : ''}`} autoComplete='false' />
            {props.icon && (
                <props.icon width='18px' className='position-absolute' />
            )}
        </InputStyledWrap>
    )
}
export const InputStyledWrap = styled.div`
    svg {
    left: 13px;
    top: 12px;
    height: 20px;
    }
`
export const InputStyled = styled.input`
    border: none;
    height: 48px;
    color: var(--darkGrey) !important;
    border-radius: 6px;
    background: var(--white);
    border: 1px solid var(--border);
    font-size: 14px;
    font-family: var(--regular);
    body.rtl &{
        font-family: var(--arRegular);
    }
    &:not(.no-icon) {
        padding-left: 50px;
    }
    &.no-icon {
        padding-left: 18px;
    }
    padding-right: 18px;
    outline: none;
    &,&::placeholder {
        font-size: 14px;
        color: #a9a9a9 !important;
    }
`
export const ContactWrapper = styled.div`
  a, button {
    display: flex;
    align-items: center;
    background:${props => props.bg ? props.bg : "var(--secondaryColor)"};
    color: ${props => props.color ? props.color : "var(--themeColor)"};
    padding: ${props => props.padding ? props.padding : "16px 24px"};
    border: ${props => props.border ? props.border : "none"};
    outline: ${props => props.border ? props.border : "none"};
    border-radius: ${props => props.radius ? props.radius : "16px"};
    /* box-shadow: ${props => props.shadow ? props.shadow : ""}; */
    line-height: 20px;
    white-space: nowrap;
    gap: 12px;
    margin:0 0px;
    transition: all 0.5s ease;
    box-shadow: 0px 16px 44px -12px rgb(0, 0, 0, .5);
    -webkit-box-shadow: 0px 16px 44px -12px rgb(0, 0, 0, .5);
    -moz-box-shadow: 0px 16px 44px -12px rgb(0, 0, 0, .5);
    span{
        font-family: var(--medium);
        padding-bottom: 2px;
        font-size: 18px;
        font-family: var(--familyRbtFlex);
        font-weight: var(--semiBold);
        /* color: ${props => props.colorSp ? props.colorSp : "var(--white)"}; */
    }
    /* svg{
        [stroke]{
            stroke: ${props => props.stroke ? props.stroke : "var(--white)"} ;
        }
        [fill]{
            fill: ${props => props.fill ? props.fill : "var(--white)"};
        }
    } */
    &:hover{
        background:var(--themeColor);
        /* outline:1px solid var(--white); */
        color:var(--bg);
        /* svg{
            [stroke]{
                stroke: var(--white) ;
            }
            [fill]{
                fill: var(--white);
            }
        } */
        span{
            color:var(--bg);
            /* font-family: var(--medium); */
        }
    }
  }
  body.rtl &{
    a, button {
        span{
            
            font-family: var(--arBold);
            font-weight: var(--bold);
            padding-bottom: 1px;
            padding-top: 1px;
            font-size: 18px;
        }
    }
  }
`
export const NextBackButton = (props) => {
    const unwantedProps = ['backIcon', 'nextIcon', 'label', 'className', 'isLoading'];
    return (
        <NextBackWrapper 
            {...sliceProps(props, unwantedProps)} 
            className={`d-flex align-items-center ${props.className || ''}`}
            disabled={props.disabled}
            >
            <button 
                {...sliceProps(props, unwantedProps)} 
                className={`${props.backIcon && 'backBtn'} ${!props.icon ? 'Btn-icon' : ''}`} 
                autoComplete='false'
                disabled={props.disabled || props.isLoading}
                >
                {props.isLoading ? (
                    <Spinner className="custom-spinner" />
                ) : (
                    <>
                        {props.backIcon && (
                            <>
                                <props.backIcon width='20px' />
                                <SpanStyled color='var(--darkGrey)' size='14px'>{props.label ? props.label : ''}</SpanStyled>
                            </>
                        )}
                        {props.nextIcon && (
                            <>
                                <SpanStyled color='var(--white)' size='14px'>{props.label ? props.label : ''}</SpanStyled>
                                <props.nextIcon width='20px' />
                            </>
                        )}
                    </>
                )}
            </button>
        </NextBackWrapper>
    )
}
export const NextBackWrapper = styled.div`
    button {
        display: flex;
        align-items: center;
        background:${props => props.bg ? props.bg : "var(--secondaryColor)"};
        color: ${props => props.color ? props.color : "var(--secondaryColor)"};
        padding: ${props => props.padding ? props.padding : "12px 20px"};
        border: ${props => props.border ? props.border : "1px solid var(--secondaryColor)"};
        outline: ${props => props.outline ? props.outline : "none"};
        border-radius: ${props => props.radius ? props.radius : "8px"};
        box-shadow: ${props => props.shadow ? props.shadow : ""};
        text-transform: uppercase;
        line-height: 20px;
        gap: 8px;
        margin:0 0px;
        transition: all 0.5s ease;
        min-width: 120px;
        justify-content: center;
        .custom-spinner {
            color: ${(props) => (props.color ? props.color : "var(--white)")};
        }
        &.backBtn{
            border:1px solid var(--border);
        }
        span{
            font-family: var(--bold);
            font-size: 16px;
            body.rtl &{
                font-family: var(--arBold);
            }
        }
        svg{
            [stroke]{
            }
            [fill]{
            }
        }
        &:hover{
            background:transparent;
            border:1px solid var(--secondaryColor);
            color:var(--themeColor);
            svg{
                [stroke]{
                    stroke: ${props => props.stroke ? props.stroke : "var(--secondaryColor)"} ;
                }
                [fill]{
                    fill: ${props => props.fill ? props.fill : "var(--secondaryColor)"};
                }
            }
            span{
                color:var(--secondaryColor);
            }
        }
        &:disabled span{
            color: var(--lightGreyText);
        }
        &:disabled:hover{
            border:1px solid var(--border) !important;
            background: var(--greyBg);
            cursor: default;
            span{
                color: var(--lightGreyText);
            }
            svg{
                [stroke]{
                    stroke: ${props => props.stroke ? props.stroke : "#cdcdcd"} ;
                }
                [fill]{
                    fill: ${props => props.fill ? props.fill : "#cdcdcd"};
                }
            }
        } 
    }
`
export const ButtonWrapper = styled.div`
  button {
    display: flex;
    align-items: center;
    background-color:${props => props.bg ? props.bg : "transparent"};
    color: ${props => props.color ? props.color : "var(--themeColor)"};
    padding: ${props => props.padding ? props.padding : "7px 16px"};
    border: ${props => props.border ? props.border : "1px solid var(--themeColor)"};
    border-radius: ${props => props.radius ? props.radius : "6px"};
    background: transparent;
    gap: 5px;
    transition: all 0.5s ease;
    &:hover{
        background-color: var(--themeColor);
        border: 1px solid var(--themeColor);
        color: var(--white);    
        span{
            color: var(--white);
        }
        svg{
            [stroke]{
                stroke: var(--white);
            }
            [fill]{
                fill: var(--white);
            }
        }
    }
    @media (max-width: 550px) {
        padding-left: 8px;
        padding-right: 8px;
        gap: 5px;
    }
}
`
export const ButtonWrapper2 = styled.div`
  button {
    display: flex;
    align-items: center;
    background:${props => props.bg ? props.bg : "var(--themeColor)"};
    color: ${props => props.color ? props.color : "var(--white)"};
    padding: ${props => props.padding ? props.padding : "15px 24px"};
    border: ${props => props.border ? props.border : "none"};
    outline: ${props => props.border ? props.border : "none"};
    border-radius: ${props => props.radius ? props.radius : "28px"};
    /* box-shadow: ${props => props.shadow ? props.shadow : ""}; */
    line-height: 20px;
    white-space: nowrap;
    gap: 12px;
    margin:0 0px;
    transition: all 0.5s ease;
    box-shadow: 0px 16px 44px -12px rgb(0, 0, 0, .5);
    -webkit-box-shadow: 0px 16px 44px -12px rgb(0, 0, 0, .5);
    -moz-box-shadow: 0px 16px 44px -12px rgb(0, 0, 0, .5);
    span{
        font-family: var(--medium);
        padding-bottom: 2px;
        color: var(--white);
        /* color: ${props => props.colorSp ? props.colorSp : "var(--white)"}; */
    }
    /* svg{
        [stroke]{
            stroke: ${props => props.stroke ? props.stroke : "var(--white)"} ;
        }
        [fill]{
            fill: ${props => props.fill ? props.fill : "var(--white)"};
        }
    } */
    &:hover{
        background: #16C457;
        /* outline:1px solid var(--white); */
        color:var(--white);
        /* svg{
            [stroke]{
                stroke: var(--white) ;
            }
            [fill]{
                fill: var(--white);
            }
        } */
        span{
            color:var(--white);
            font-family: var(--medium);
        }
    }
  }
  body.rtl &{
    button {
        span{
            
            font-family: var(--arRegular);
            padding-bottom: 1px;
            padding-top: 1px;
            font-size: 18px;
        }
    }
  }
`


export const SelectionDropdown = (props) => {
    const unwantedProps = ["options", "register", "validationRules"];
    const { register, validationRules, name } = props;
    const dropdownRef = useRef(null);
    return (
        <DropdownStyled
            {...sliceProps(props, unwantedProps)}
            ref={dropdownRef}
            arrow={ArrowDown}
            {...(register && register(name, validationRules))}
        >
            <option value="" className="label">
                {props.placeholder && props.placeholder}
            </option>
            {props.options &&
                props.options.length > 0 &&
                props.options.map((option, index) => (
                    <option key={index} value={option.value}>
                        {option.label}
                    </option>
                ))}
        </DropdownStyled>
    );
};
const DropdownStyled = styled.select`
  height: 48px;
    color: var(--darkGrey) !important;
    border-radius: 6px;
    background: var(--white);
    border: 1px solid var(--border);
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  outline: none;
  color: var(--text);
  font-family: var(--regular);
    body.rtl &{
        font-family: var(--arRegular);
    }
  cursor: pointer;
  .label {
    color: var(--darkGrey);
  }
  &::placeholder {
    color: var(--text2);
  }
  option[disabled] {
    color: var(--text2);
  }
`;

export const AboutBox = (props) => {
    const unwantedProps = ['icon', 'label', 'className', 'stats'];
    return (
        <AboutBoxWrapper {...sliceProps(props, unwantedProps)} bgimage={props.bgimage} className={`d-flex ${props.className || ''}`}>
            <Box className='stats'>
                {props.stats}
            </Box>
            <SpanStyled color='var(--themeColor)' size='20px' family='var(--regular)'>{props.statsTitle}</SpanStyled>
        </AboutBoxWrapper>
    )
}
const AboutBoxWrapper = styled.div`
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
    background-image: url(${props => props.bgimage});
    background-size: cover;
    background-position: center;
    border-radius: 16px;
    border: 1px solid var(--stroke);
    height: 174px;
    padding: 0 30px 0 30px;
    .stats{
        display: block;
        font-size: 40px;
        font-family: var(--bold);
        color: var(--secondaryColor);
        direction: ltr;
        width: 100%;
        text-align: left;
    }
    body.rtl &{
        *{
            text-align: right;
        }
        span{
            font-family: var(--arLT);
        }
    }
    @media (max-width: 991px) {
        padding: 0 20px 0 15px;
    }
    
`


export const TextButton = (props) => {
    const unwantedProps = ['icon', 'label', 'bgBtn', 'clName', 'clNameMain'];
    return (
        <TextButtonWrapper {...sliceProps(props, unwantedProps)} className={`d-flex align-items-center btn-text ${props.clNameMain ? props.clNameMain : ''}`}>
            <button className={` ${props.clName ? props.clName : ''} ${props.bgBtn ? props.bgBtn : ''} ${!props.icon ? 'Btn-icon' : ''} `} autoComplete='false'>
                {props.icon && (
                    <Box className='contact-svg text-center justify-content-center d-flex'>
                        <props.icon width='28px' />
                    </Box>
                    
                )}
                <SpanStyled color='var(--bg2)' dir='ltr' size='16px'  family="var(--familyRbt)" weight="var(--medium)" >{props.label ? props.label : ''}</SpanStyled>

            </button>
        </TextButtonWrapper>
    )
}
const TextButtonWrapper = styled.div`

    .btn-text {
        
        
    }
    & button{
        background:none;
        border:none;
        display:flex;
        align-items:center;
        gap:6px;

        & span{
            font-family: var(--medium);
        }
    }
`

export const TextWithIcon = (props) => (
    <TextWithStyledWrapper color={props.color} className={`d-flex cInfoIt ${props.desc ? 'align-items-start' : 'align-items-center'}`}>
        <Box className='d-flex align-items-center justify-content-center contact-svg'>
            <props.icon width='26px' />
        </Box>
        <Box>
            <Box className='mb-0 contact-text' size={props.headingSize ? props.headingSize : '16px'}
                color={!props.alsotextColor ? 'var(--bg2)' : 'var(--bg2)'}
                dangerouslySetInnerHTML={{ __html: props.title }}>
            </Box>
            {props.desc ?
                <TextStyled className='text-uppercase' color={'var(--bg2)'} size='16px' family="var(--medium)" >
                    {props?.desc}
                </TextStyled>
                : null}
        </Box>
    </TextWithStyledWrapper>
)

const TextWithStyledWrapper = styled.div`
  svg {
      [stroke] {
          stroke: ${({ color }) => color ? color : ''};
      }
  }
`
